export const NAVBAR_HEIGHT = 50; // px
export const NAVBAR_SPACE = { xs: "10px", sm: "50px", md: "50px" };
